import { type VariantProps } from 'class-variance-authority';
import React from 'react';

import { buttonVariants, cn } from '@/utils/utils';

interface IconButtonProps
  extends
    Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'>,
    VariantProps<typeof buttonVariants> {
  'aria-label': string;
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export function IconButton({
  'aria-label': ariaLabel,
  children,
  className,
  disabled = false,
  onClick,
  size = 'icon',
  variant = 'ghost',
  ...props
}: IconButtonProps) {
  return (
    <div
      aria-disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        buttonVariants({ size, variant }),
        disabled && 'pointer-events-none opacity-50',
        className,
      )}
      onClick={disabled ? undefined : onClick}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick?.();
        }
      }}
      role="button"
      tabIndex={disabled ? -1 : 0}
      {...props}
    >
      {children}
    </div>
  );
}
